"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKetteConfigurationModel = exports.ketteConfigurationModelUseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ConfigurationModel_1 = require("./ConfigurationModel");
exports.ketteConfigurationModelUseableDef = {
    parent: ConfigurationModel_1.configurationModelUseableDef,
    validation: {
        Kette: true,
        Espool: false,
    },
};
exports.isKetteConfigurationModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.ketteConfigurationModelUseableDef);
//# sourceMappingURL=KetteConfigurationModel.js.map